// Plain-text version of editor HTML, used for the character count and SMS cost.
// Keep in sync with Messages/Pagaspot.Messages/Services/MessageText.cs, which
// builds the text actually sent by SMS and push.
const BLOCK_TAGS = ['P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'BLOCKQUOTE', 'PRE', 'DIV'];

const nodeToText = (node, listPrefix = '') => {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.textContent;
  }
  if (node.nodeType !== Node.ELEMENT_NODE) {
    return '';
  }

  const children = (prefixFor) => Array.from(node.childNodes)
    .map((child, i) => nodeToText(child, prefixFor ? prefixFor(i) : ''))
    .join('');

  switch (node.tagName) {
    case 'BR':
      return '\n';
    case 'HR':
      return '\n---\n';
    case 'UL':
      return `${children(() => '• ')}\n`;
    case 'OL': {
      const start = parseInt(node.getAttribute('start'), 10) || 1;
      return `${children((i) => `${start + i}. `)}\n`;
    }
    case 'LI':
      return `${listPrefix}${children().trim()}\n`;
    case 'A': {
      const text = children();
      const href = node.getAttribute('href');
      return href && href !== text ? `${text} (${href})` : text;
    }
    default:
      if (BLOCK_TAGS.includes(node.tagName)) {
        return `${children()}\n`;
      }
      return children();
  }
};

const htmlToText = (html) => {
  if (!html) return '';
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return nodeToText(doc.body)
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};

export default htmlToText;
